// import React, { useState } from "react";
// import { Form, Select, Button, InputNumber, Modal } from "antd";
// import dayjs from "dayjs";

// const { Option } = Select;

// const AddReminder = ({scheduleDate}) => {
//     const [reminderInputs, setReminderInputs] = useState([0]); // Tracks indices for dynamic inputs
//     const [reminders, setReminders] = useState([]);
//     console.log(reminders, "reminders");
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [customValue, setCustomValue] = useState(0);
//     const [customUnit, setCustomUnit] = useState("minutes");
//     const [editingIndex, setEditingIndex] = useState(null); // Tracks which input is being edited

//     const calculateDateTime = (amount, unit) => {
//         const now = dayjs();
//         const calculatedTime = now.subtract(amount, unit);
//         return {
//             remindersDate: calculatedTime.startOf("day").unix(),
//             remindersTime: calculatedTime.unix(),
//         };
//     };

//     const handleNotificationChange = (index, value) => {
//         if (value === "custom") {
//             setEditingIndex(index);
//             setIsModalOpen(true);
//         } else {
//             const timeMap = {
//                 "5m": { amount: 5, unit: "minutes" },
//                 "10m": { amount: 10, unit: "minutes" },
//                 "15m": { amount: 15, unit: "minutes" },
//                 "30m": { amount: 30, unit: "minutes" },
//                 "1h": { amount: 1, unit: "hours" },
//                 "1d": { amount: 1, unit: "days" },
//             };
//             const { amount, unit } = timeMap[value];
//             const newReminder = calculateDateTime(amount, unit);

//             // Replace or add the reminder at the correct index
//             const updatedReminders = [...reminders];
//             updatedReminders[index] = newReminder;
//             setReminders(updatedReminders);
//         }
//     };

//     const handleAddMoreReminder = () => {
//         setReminderInputs([...reminderInputs, reminderInputs.length]);
//     };

//     const handleCustomSubmit = () => {
//         if (editingIndex !== null) {
//             const newReminder = calculateDateTime(customValue, customUnit);
//             const updatedReminders = [...reminders];
//             updatedReminders[editingIndex] = newReminder;
//             setReminders(updatedReminders);
//         }
//         setIsModalOpen(false);
//     };
//     return (
//         <div>
//             <h2>Add Reminder</h2>
//             <Form layout="vertical">
//                 {reminderInputs.map((inputIndex) => (
//                     <Form.Item key={inputIndex} label="" prefixCls="custom-input">
//                         <Select
//                             onChange={(value) => handleNotificationChange(inputIndex, value)}
//                             allowClear
//                             placeholder="Select Notification Time"
//                             style={{height:"70px"}}
//                         >
//                             <Option value="5m">05 Minutes Before</Option>
//                             <Option value="10m">10 Minutes Before</Option>
//                             <Option value="15m">15 Minutes Before</Option>
//                             <Option value="30m">30 Minutes Before</Option>
//                             <Option value="1h">01 Hour Before</Option>
//                             <Option value="1d">01 Day Before</Option>
//                             <Option value="custom">Custom</Option>
//                         </Select>
//                     </Form.Item>
//                 ))}
//                 <div style={{display:"flex",justifyContent:"end"}}>
//                     <Button onClick={handleAddMoreReminder} style={{ background: "transparent", border: "none", color: "#0DA982", fontSize: "14px", fontWeight: "400", marginBottom: "31px" }}>
//                         + Add More Reminder
//                     </Button>
//                 </div>
//             </Form>

//             <Modal
//                 title="Custom Notification"
//                 open={isModalOpen}
//                 onCancel={() => setIsModalOpen(false)}
//                 onOk={handleCustomSubmit}
//             >
//                 <div style={{ display: "flex", gap: "16px" }}>
//                     <InputNumber
//                         min={1}
//                         value={customValue}
//                         onChange={(value) => setCustomValue(value || 0)}
//                     />
//                     <Select value={customUnit} onChange={(value) => setCustomUnit(value)}>
//                         <Option value="minutes">Minutes</Option>
//                         <Option value="hours">Hours</Option>
//                         <Option value="days">Days</Option>
//                         <Option value="weeks">Weeks</Option>
//                     </Select>
//                 </div>
//             </Modal>
//         </div>
//     );
// };

// export default AddReminder;

// import React, { useState } from "react";
// import { Form, Select, Button, InputNumber, Modal } from "antd";
// import dayjs from "dayjs";

// const { Option } = Select;

// const AddReminder = ({ scheduleDate, scheduleTime, reminders, setReminders }) => {
//     const [reminderInputs, setReminderInputs] = useState([0]); // Tracks indices for dynamic inputs

//     console.log(reminders, "reminders")
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [customValue, setCustomValue] = useState(0);
//     const [customUnit, setCustomUnit] = useState("minutes");
//     const [editingIndex, setEditingIndex] = useState(null); // Tracks which input is being edited

//     // Combine scheduleDate and scheduleTime properly and calculate the reminder time
//     const calculateDateTime = (amount, unit) => {
//         // Convert scheduleDate (timestamp in milliseconds) to a Day.js object
//         const scheduleDay = dayjs(scheduleDate);
//         console.log(scheduleDay,"scheduleDay")

//         // Add scheduleTime (in seconds) to the scheduleDay
//         const finalSchedule = scheduleDay.add(scheduleTime, "seconds");

//         // Subtract the reminder time
//         const calculatedTime = finalSchedule.subtract(amount, unit);

//         return {
//             reminderDate: calculatedTime.startOf("day").unix(), // Start of the reminder day (in seconds)
//             reminderTime: calculatedTime.unix(), // Exact reminder time (in seconds)
//         };
//     };





//     const handleNotificationChange = (index, value) => {
//         if (value === "custom") {
//             setEditingIndex(index);
//             setIsModalOpen(true);
//         } else {
//             const timeMap = {
//                 "5m": { amount: 5, unit: "minutes" },
//                 "10m": { amount: 10, unit: "minutes" },
//                 "15m": { amount: 15, unit: "minutes" },
//                 "30m": { amount: 30, unit: "minutes" },
//                 "1h": { amount: 1, unit: "hours" },
//                 "1d": { amount: 1, unit: "days" },
//             };
//             const { amount, unit } = timeMap[value];
//             const newReminder = calculateDateTime(amount, unit);

//             // Replace or add the reminder at the correct index
//             const updatedReminders = [...reminders];
//             updatedReminders[index] = newReminder;
//             setReminders(updatedReminders);
//         }
//     };

//     const handleAddMoreReminder = () => {
//         setReminderInputs([...reminderInputs, reminderInputs.length]);
//     };

//     const handleCustomSubmit = () => {
//         if (editingIndex !== null) {
//             const newReminder = calculateDateTime(customValue, customUnit);
//             const updatedReminders = [...reminders];
//             updatedReminders[editingIndex] = newReminder;
//             setReminders(updatedReminders);
//         }
//         setIsModalOpen(false);
//     };

//     return (
//         <div>
//             <h2>Add Reminder</h2>
//             <Form layout="vertical">
//                 {reminderInputs.map((inputIndex) => (
//                     <Form.Item key={inputIndex} label="" prefixCls="custom-input">
//                         <Select
//                             onChange={(value) => handleNotificationChange(inputIndex, value)}
//                             allowClear
//                             placeholder="Select Notification Time"
//                             style={{ height: "70px" }}
//                         >
//                             <Option value="5m">05 Minutes Before</Option>
//                             <Option value="10m">10 Minutes Before</Option>
//                             <Option value="15m">15 Minutes Before</Option>
//                             <Option value="30m">30 Minutes Before</Option>
//                             <Option value="1h">01 Hour Before</Option>
//                             <Option value="1d">01 Day Before</Option>
//                             <Option value="custom">Custom</Option>
//                         </Select>
//                     </Form.Item>
//                 ))}
//                 <div style={{ display: "flex", justifyContent: "end" }}>
//                     <Button
//                         onClick={handleAddMoreReminder}
//                         style={{
//                             background: "transparent",
//                             border: "none",
//                             color: "#0DA982",
//                             fontSize: "14px",
//                             fontWeight: "400",
//                             marginBottom: "31px",
//                         }}
//                     >
//                         + Add More Reminder
//                     </Button>
//                 </div>
//             </Form>

//             <Modal
//                 title="Custom Notification"
//                 open={isModalOpen}
//                 onCancel={() => setIsModalOpen(false)}
//                 onOk={handleCustomSubmit}
//             >
//                 <div style={{ display: "flex", gap: "16px" }}>
//                     <InputNumber
//                         min={1}
//                         value={customValue}
//                         onChange={(value) => setCustomValue(value || 0)}
//                     />
//                     <Select value={customUnit} onChange={(value) => setCustomUnit(value)}>
//                         <Option value="minutes">Minutes</Option>
//                         <Option value="hours">Hours</Option>
//                         <Option value="days">Days</Option>
//                         <Option value="weeks">Weeks</Option>
//                     </Select>
//                 </div>
//             </Modal>
//         </div>
//     );
// };

// export default AddReminder;


// import React, { useState } from "react";
// import { Form, Select, Button, InputNumber, Modal } from "antd";
// import dayjs from "dayjs";
// import { CloseOutlined } from "@ant-design/icons";

// const { Option } = Select;

// const AddReminder = ({
//     scheduleDate,
//     scheduleTime,
//     reminders,
//     setReminders
// }) => {
//     console.log(reminders,"reminders")
//     const [reminderInputs, setReminderInputs] = useState([0]);
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [customValue, setCustomValue] = useState(0);
//     const [customUnit, setCustomUnit] = useState("minutes");
//     const [editingIndex, setEditingIndex] = useState(null);

//     const calculateDateTime = (
//         scheduleDate,
//         scheduleTime,
//         amount,
//         unit
//     ) => {
//         const scheduleDateTime = dayjs.unix(scheduleTime);
//         const calculatedTime = scheduleDateTime.subtract(
//             amount,
//             unit
//         );
//         return {
//             reminderDate: scheduleDate,
//             reminderTime: calculatedTime.unix(),
//         };
//     };

//     const handleNotificationChange = (index, value) => {
//         if (value === "custom") {
//             setEditingIndex(index);
//             setIsModalOpen(true);
//         } else {
//             const timeMap = {
//                 "5m": { amount: 5, unit: "minutes" },
//                 "10m": { amount: 10, unit: "minutes" },
//                 "15m": { amount: 15, unit: "minutes" },
//                 "30m": { amount: 30, unit: "minutes" },
//                 "1h": { amount: 1, unit: "hours" },
//                 "1d": { amount: 1, unit: "days" },
//             };
//             const { amount, unit } = timeMap[value];
//             const newReminder = calculateDateTime(
//                 scheduleDate,
//                 scheduleTime,
//                 amount,
//                 unit
//             );

//             const updatedReminders = [...reminders];
//             updatedReminders[index] = newReminder;
//             setReminders(updatedReminders);
//         }
//     };

//     const handleAddMoreReminder = () => {
//         setReminderInputs([...reminderInputs, reminderInputs.length]);
//     };

//     const handleRemoveReminder = (index) => { const updatedInputs = reminderInputs.filter((_, i) => i !== index); setReminderInputs(updatedInputs); const updatedReminders = reminders.filter((_, i) => i !== index); setReminders(updatedReminders); };

//     const handleCustomSubmit = () => {
//         if (editingIndex !== null) {
//             const newReminder = calculateDateTime(
//                 scheduleDate,
//                 scheduleTime,
//                 customValue,
//                 customUnit
//             );
//             const updatedReminders = [...reminders];
//             updatedReminders[editingIndex] = newReminder;
//             setReminders(updatedReminders);
//         }
//         setIsModalOpen(false);
//     };
//     return (
//         <div>
//             <h2>Add Reminder</h2>
//             <Form layout="vertical">
//                 {reminderInputs.map((inputIndex, index) => (
//                     <Form.Item key={inputIndex} label="" prefixCls="custom-input">
//                         <Select
//                             onChange={(value) => handleNotificationChange(inputIndex, value)}
//                             // allowClear
//                             placeholder="Select Notification Time"
//                             prefixCls="custom-add-reminder"
//                         >
//                             <Option value="5m">05 Minutes Before</Option>
//                             <Option value="10m">10 Minutes Before</Option>
//                             <Option value="15m">15 Minutes Before</Option>
//                             <Option value="30m">30 Minutes Before</Option>
//                             <Option value="1h">01 Hour Before</Option>
//                             <Option value="1d">01 Day Before</Option>
//                             <Option value="custom">Custom</Option>
//                         </Select>
//                         {index != 0 && 
//                             <Button type="text" icon={<CloseOutlined style={{ color: "#fff" }} />} onClick={() => handleRemoveReminder(index)} />
//                         }
                        
//                     </Form.Item>
//                 ))}
//                 <div style={{ display: "flex", justifyContent: "end" }}>
//                     <Button
//                         onClick={handleAddMoreReminder}
//                         style={{
//                             background: "transparent",
//                             border: "none",
//                             color: "#0DA982",
//                             fontSize: "14px",
//                             fontWeight: "400",
//                             marginBottom: "31px",
//                         }}
//                     >
//                         + Add More Reminder
//                     </Button>
//                 </div>
//             </Form>

//             <Modal
//                 title="Custom Notification"
//                 open={isModalOpen}
//                 onCancel={() => setIsModalOpen(false)}
//                 onOk={handleCustomSubmit}
//             >
//                 <div style={{ display: "flex", gap: "16px" }}>
//                     <InputNumber
//                         min={1}
//                         value={customValue}
//                         onChange={(value) => setCustomValue(value || 0)}
//                     />
//                     <Select value={customUnit} onChange={(value) => setCustomUnit(value)}>
//                         <Option value="minutes">Minutes</Option>
//                         <Option value="hours">Hours</Option>
//                         <Option value="days">Days</Option>
//                         <Option value="weeks">Weeks</Option>
//                     </Select>
//                 </div>
//             </Modal>
//         </div>
//     );
// };
// export default AddReminder;

import React, { useState } from "react";
import { Form, Select, Button, InputNumber, Modal } from "antd";
import dayjs from "dayjs";
import { CloseOutlined } from "@ant-design/icons";

const { Option } = Select;

const AddReminder = ({ scheduleDate, scheduleTime, reminders, setReminders }) => {
    console.log(reminders, "reminders");

    const [reminderInputs, setReminderInputs] = useState([0]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [customValue, setCustomValue] = useState(0);
    const [customUnit, setCustomUnit] = useState("minutes");
    const [editingIndex, setEditingIndex] = useState(null);
    const [selectedValues, setSelectedValues] = useState({}); // Store selected options

    const calculateDateTime = (scheduleDate, scheduleTime, amount, unit) => {
        const scheduleDateTime = dayjs.unix(scheduleTime);
        const calculatedTime = scheduleDateTime.subtract(amount, unit);
        return {
            reminderDate: scheduleDate,
            reminderTime: calculatedTime.unix(),
        };
    };

    const handleNotificationChange = (index, value) => {
        if (value === "custom") {
            setEditingIndex(index);
            setIsModalOpen(true);
        } else {
            const timeMap = {
                "5m": { amount: 5, unit: "minutes" },
                "10m": { amount: 10, unit: "minutes" },
                "15m": { amount: 15, unit: "minutes" },
                "30m": { amount: 30, unit: "minutes" },
                "1h": { amount: 1, unit: "hours" },
                "1d": { amount: 1, unit: "days" },
            };
            const { amount, unit } = timeMap[value];
            const newReminder = calculateDateTime(scheduleDate, scheduleTime, amount, unit);

            const updatedReminders = [...reminders];
            updatedReminders[index] = newReminder;
            setReminders(updatedReminders);

            // Update selected values
            setSelectedValues({ ...selectedValues, [index]: value });
        }
    };

    const handleAddMoreReminder = () => {
        setReminderInputs([...reminderInputs, reminderInputs.length]);
    };

    const handleRemoveReminder = (index) => {
        const updatedInputs = reminderInputs.filter((_, i) => i !== index);
        setReminderInputs(updatedInputs);

        const updatedReminders = reminders.filter((_, i) => i !== index);
        setReminders(updatedReminders);

        const updatedSelectedValues = { ...selectedValues };
        delete updatedSelectedValues[index];
        setSelectedValues(updatedSelectedValues);
    };

    const handleCustomSubmit = () => {
        if (editingIndex !== null) {
            const newReminder = calculateDateTime(scheduleDate, scheduleTime, customValue, customUnit);
            const updatedReminders = [...reminders];
            updatedReminders[editingIndex] = newReminder;
            setReminders(updatedReminders);

            // Update selected values to show the custom time
            setSelectedValues({
                ...selectedValues,
                [editingIndex]: `${customValue} ${customUnit}`,
            });
        }
        setIsModalOpen(false);
    };

    return (
        <div>
            <h2>Add Reminder</h2>
            <Form layout="vertical">
                {reminderInputs.map((inputIndex, index) => (
                    <Form.Item key={inputIndex} label="" prefixCls="custom-input">
                        <Select
                            value={selectedValues[index] || undefined}
                            onChange={(value) => handleNotificationChange(inputIndex, value)}
                            placeholder="Select Notification Time"
                            prefixCls="custom-add-reminder"
                        >
                            <Option value="5m">05 Minutes Before</Option>
                            <Option value="10m">10 Minutes Before</Option>
                            <Option value="15m">15 Minutes Before</Option>
                            <Option value="30m">30 Minutes Before</Option>
                            <Option value="1h">01 Hour Before</Option>
                            <Option value="1d">01 Day Before</Option>
                            <Option value="custom">Custom</Option>
                        </Select>
                        {index !== 0 && (
                            <Button
                                type="text"
                                icon={<CloseOutlined style={{ color: "#fff" }} />}
                                onClick={() => handleRemoveReminder(index)}
                            />
                        )}
                    </Form.Item>
                ))}
                <div style={{ display: "flex", justifyContent: "end" }}>
                    <Button
                        onClick={handleAddMoreReminder}
                        style={{
                            background: "transparent",
                            border: "none",
                            color: "#0DA982",
                            fontSize: "14px",
                            fontWeight: "400",
                            marginBottom: "31px",
                        }}
                    >
                        + Add More Reminder
                    </Button>
                </div>
            </Form>

            <Modal
                title="Custom Notification"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                onOk={handleCustomSubmit}
            >
                <div style={{ display: "flex", gap: "16px" }}>
                    <InputNumber
                        min={1}
                        value={customValue}
                        onChange={(value) => setCustomValue(value || 0)}
                    />
                    <Select value={customUnit} onChange={(value) => setCustomUnit(value)}>
                        <Option value="minutes">Minutes</Option>
                        <Option value="hours">Hours</Option>
                        <Option value="days">Days</Option>
                        <Option value="weeks">Weeks</Option>
                    </Select>
                </div>
            </Modal>
        </div>
    );
};

export default AddReminder;
